<template>
  <div>

    <section>
      <div class="row">
        <div class="col-12"><b>Demographics</b></div>
        <div class="col-12"><div class="img h2"></div></div>
      </div>
    </section>

    <section>
      <div class="row">
        <div class="col-12"><b>Specifics:</b></div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="img h1"></div></div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="img h1"></div></div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="img h1"></div></div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="img h1"></div></div>
      </div>
    </section>

  </div>
</template>

<script>
  export default {
    name: 'metrics',
    data () {
      return {
      }
    },
    created () {
      this.$parent.$parent.prevPage = {name: 'article-detail'}
      this.$parent.$parent.nextPage = {name: 'article-interact'}
      this.$parent.$parent.prevSlide = {name: 'article-metrics-geographics'}
      this.$parent.$parent.nextSlide = false
    }
  }
</script>


<style scoped lang="scss">
  .title {
    color: $primary-color;
    font-size: 32px;
  }
  section {
    margin: 20px auto;
    padding-bottom: 12px;
  &:not(:last-child) {
     border-bottom: 1px solid #cccccc;
   }
  p {
    font-size: 14px;
    text-decoration: underline;
    color: $grey-font;
  }
  .text-right {
    font-size: 12px;
    line-height: 24px;
    font-style: italic;
  }
  .img {
    border: 1px solid #cccccc;
    background-color: #eeeeee;
    width: 100%;
  &.h1 {
     height: 160px;
   }
  &.h2 {
     height: calc(320px + 0.5rem);
   }
  &.h3 {
     height: calc(480px + 1rem);
   }
  }
  .btn {
    padding: 10px;
    border: 1px solid #dfdfdf;
    width: 100%;
    text-align: center;
    font-size: 12px;
    margin-bottom: 10px;
  &.active {
     background-color: #cccccc;
   }
  }
  }
</style>



// WEBPACK FOOTER //
// DemographicsPage.vue?2bd0556a